/* OsLinkStatusRenderer.js */

"use strict";

const _ = require("lodash");

class IotOsLinkStatusRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("oslink-status-column");
        this._rootElem.component = this._model;
        this._onOsLinkStatus = this._onOsLinkStatus.bind(this);

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    async _shutdown() {
        this._unregisterListeners();
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        return Promise.resolve();
    }

    _registerListeners() {
        this._model.on("OsLinkStatus", this._onOsLinkStatus);
    }

    _unregisterListeners() {
        this._model.removeListener("OsLinkStatus", this._onOsLinkStatus);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setOsLinkStatus(this._model.getOsLinkStatus());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onOsLinkStatus(newVal) {
        this._setOsLinkStatus(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setOsLinkStatus(newVal) {
        // EXTERNAL ADDED

        if (!newVal) {
            newVal = "QUEUED";
        }

        const statusVal = _.upperCase(this._model._linkStatusValues[newVal] || newVal);
        const odmOsLink = this._model._entity;

        let titleMsg = "";
        switch (newVal) {
            case "EXTERNAL":
                titleMsg = `No Download Queued.
Image to be added manually to the bundle.`;
                break;
            case "QUEUED":
                titleMsg = `New Download Queued
Download Attempts: ${odmOsLink.downloadAttempts || "Unknown"}`;
                break;
            case "DOWNLOADING":
                titleMsg = `Download Started On: ${
                    this._formatToDate(odmOsLink.downloadStartedOn) || "Unknown"
                }
Download Attempts: ${odmOsLink.downloadAttempts || "Unknown"}`;
                break;
            case "DOWNLOADED":
                titleMsg = `Download Started On: ${
                    this._formatToDate(odmOsLink.downloadStartedOn) || "Unknown"
                }
Download Completed On: ${this._formatToDate(odmOsLink.downloadCompletedOn) || "Unknown"}
Download Attempts: ${odmOsLink.downloadAttempts || "Unknown"}`;
                break;
            case "DOWNLOAD FAILED":
                titleMsg = `Download Started On: ${
                    this._formatToDate(odmOsLink.downloadStartedOn) || "Unknown"
                }
Download Attempts: ${odmOsLink.downloadAttempts || "Unknown"}
Error Message: ${odmOsLink.errorMsg || "Unknown"}`;
                break;
            case "DOWNLOAD ABANDONED":
                titleMsg = `Download Started On: ${
                    this._formatToDate(odmOsLink.downloadStartedOn) || "Unknown"
                }
Download Attempts: ${odmOsLink.downloadAttempts || "Unknown"}
Error Message: ${odmOsLink.errorMsg || "Unknown"}`;
                break;
            case "UPLOADING":
                titleMsg = `Upload Started On: ${
                    this._formatToDate(odmOsLink.uploadStartedOn) || "Unknown"
                }`;
                break;
            case "UPLOADED":
                titleMsg = `Upload Started On: ${
                    this._formatToDate(odmOsLink.uploadStartedOn) || "Unknown"
                }
Upload Completed On: ${this._formatToDate(odmOsLink.uploadCompletedOn) || "Unknown"}`;
                break;
            case "UPLOAD FAILED":
                titleMsg = `Upload Started On: ${
                    this._formatToDate(odmOsLink.uploadStartedOn) || "Unknown"
                }
Error Message: ${odmOsLink.errorMsg || "Unknown"}`;
                break;
            default:
                titleMsg = statusVal;
                break;
        }
        const statusEl = document.createElement("span");
        statusEl.title = titleMsg;
        statusEl.innerText = statusVal;
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(statusEl);
    }

    _formatToDate(date) {
        if (date) {
            return new Date(date).toLocaleDateString() + " " + new Date(date).toLocaleTimeString();
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = IotOsLinkStatusRenderer;
